var map = {
	"./04.png": 154,
	"./EN/02C.png": 155,
	"./EN/03.png": 156,
	"./ES/02C.png": 157,
	"./ES/03.png": 158,
	"./btn-en.png": 159,
	"./btn-english.png": 160,
	"./btn-es.png": 161,
	"./btn-espaคol.png": 162,
	"./toggle_icon.png": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;